import { Node } from '@tiptap/core'
import { Suggestions, replaceText } from '../plugins/Suggestions'
import { store } from '@/store'
import router from '@/router'

export const Mention = Node.create({
  name: 'mention',

  defaultOptions: {
    matcher: {
      char: '@',
      allowSpaces: true,
      startOfLine: false
    },
    mentionClass: 'mention'
  },

  addAttributes () {
    return {
      href: {
        default: null
      },
      title: {
        default: null
      },
      label: {
        default: null
      },
      color: {
        default: null
      }
    }
  },

  group: 'inline',
  inline: true,
  selectable: false,
  atom: true,

  parseHTML () {
    return [
      {
        tag: 'button.mention',
        getAttrs: dom => {
          const href = dom.getAttribute('href')
          const title = dom.getAttribute('title')
          return { href, title }
        }
      }
    ]
  },

  renderHTML ({ node }) {
    return [
      'button',
      {
        class: this.options.mentionClass,
        href: node.attrs.href,
        title: node.attrs.title
      },
      `${this.options.matcher.char}${node.attrs.title}`
    ]
  },

  addProseMirrorPlugins () {
    return [
      Suggestions({
        command: ({ range, attrs, schema }) => replaceText(range, schema.nodes.mention, attrs),
        appendText: ' ',
        matcher: this.options.matcher,
        items: this.options.items,
        onEnter: this.options.onEnter,
        onChange: this.options.onChange,
        onExit: this.options.onExit,
        onKeyDown: this.options.onKeyDown,
        onFilter: this.options.onFilter
      })
    ]
  },

  addNodeView () {
    return ({ node }) => {
      const open = () => {
        if (router.currentRoute.value.name !== 'Share') {
          router.push(node.attrs.href).catch(() => {})
        }
      }

      if (node.attrs.label === 'users') {
        const dom = document.createElement('button')
        const colorLabel = document.createElement('span')
        const titleNode = document.createElement('span')

        colorLabel.classList.add('w-3', 'rounded-2', 'h-18', 'mr-7')
        colorLabel.style = node.attrs.color

        const classes = store.getters.isDarkMode ? ['hover:bg-dark-500', 'bg-sidebar'] : ['hover:bg-menu-hover', 'bg-light']
        dom.classList.add('mention', 'cursor-default', 'anim-color', ...classes)

        window.addEventListener('darkModeEvent', (e) => {
          if (e.detail.isDarkMode) {
            dom.classList.remove('hover:bg-menu-hover', 'bg-light')
            dom.classList.add('hover:bg-dark-500', 'bg-sidebar')
          } else {
            dom.classList.remove('hover:bg-dark-500', 'bg-sidebar')
            dom.classList.add('hover:bg-menu-hover', 'bg-light')
          }
        }, false)

        titleNode.innerHTML = node.attrs.title

        dom.appendChild(colorLabel)
        dom.appendChild(titleNode)

        return {
          dom
        }
      } else {
        const dom = document.createElement('button')
        const icon = document.createElement('i')
        const titleNode = document.createElement('span')

        icon.classList.add('icon-article')
        icon.classList.add('mr-5')

        const classes = store.getters.isDarkMode ? ['hover:bg-dark-500', 'bg-sidebar'] : ['hover:bg-menu-hover', 'bg-light']
        dom.classList.add('mention', 'anim-color', ...classes)

        window.addEventListener('darkModeEvent', (e) => {
          if (e.detail.isDarkMode) {
            dom.classList.remove('hover:bg-menu-hover', 'bg-light')
            dom.classList.add('hover:bg-dark-500', 'bg-sidebar')
          } else {
            dom.classList.remove('hover:bg-dark-500', 'bg-sidebar')
            dom.classList.add('hover:bg-menu-hover', 'bg-light')
          }
        }, false)

        let title = node.attrs.title

        if (title === null) {
          const id = parseInt(node.attrs.href.split('=')[1])
          const project = store.state.project.projects.find(p => p.id === id)
          title = project?.title
        }

        titleNode.innerHTML = title

        dom.setAttribute('title', title)
        dom.addEventListener('click', open)
        dom.appendChild(icon)
        dom.appendChild(titleNode)

        return {
          dom,
          destroy () {
            dom.removeEventListener('click', open)
          }
        }
      }
    }
  }
})
